/**
 * The OpenComply mark — "OC monogram" (Concept C).
 *
 * A closed O (comply: a complete, verified loop) meeting an open C (open:
 * transparent, accessible). The two initials read as one geometric figure.
 *
 * Stroke-based and drawn in `currentColor`, so it inherits `text-brand`
 * wherever it is placed and scales cleanly from the sidebar down to a favicon.
 * The favicon version lives at `public/favicon.svg` and must be kept in step
 * with this geometry.
 */

import type { SVGProps } from 'react';

export function Logo({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      role="img"
      aria-label="OpenComply"
      {...props}
    >
      {/* O — closed loop */}
      <circle cx="19" cy="24" r="12.5" stroke="currentColor" strokeWidth="4" />
      {/* C — open to the right, interlocking with the O */}
      <path
        d="M38.5 16.2a12.5 12.5 0 1 0 0 15.6"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}
